import React from 'react'
import classNames from 'classnames'
import { ButtonTextLinkProps } from './ButtonTextLink.d'
import Button from '@toasttab/shared/src/components/atoms/Button/Button'
import TextLink from '@toasttab/shared/src/components/molecules/TextLink/TextLink'
import { getSize, getVariation } from '@toasttab/shared/src/utils/Craft/button'

const ButtonTextLink = ({
  buttonPadding,
  buttonVariations,
  classes,
  ctaLabel,
  ctaLink,
  componentClass,
  linkIcons,
  linkLabel,
  linkTarget
}: ButtonTextLinkProps) => {
  const containerClass = classNames(classes, componentClass)

  return (
    <div className={containerClass} data-testid='buttonTextLink'>
      <Button
        classes='w-full md:mr-4'
        href={ctaLink}
        size={getSize(buttonPadding)}
        variation={getVariation(buttonVariations)}
      >
        {ctaLabel}
      </Button>

      <TextLink
        classes='pt-6 lg:pt-0 self-center'
        href={linkTarget}
        icon={linkIcons}
        text={linkLabel}
      />
    </div>
  )
}

export default ButtonTextLink
